import { render, staticRenderFns } from "./IndexImagesList.vue?vue&type=template&id=af0c0724&scoped=true&"
import script from "./IndexImagesList.vue?vue&type=script&lang=js&"
export * from "./IndexImagesList.vue?vue&type=script&lang=js&"
import style0 from "./IndexImagesList.vue?vue&type=style&index=0&id=af0c0724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c0724",
  null
  
)

export default component.exports